
import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Base layout for all landing pages
 * This component serves as the foundation for all landing pages,
 * allowing each landing page to have its own unique design while
 * sharing common structural elements if needed.
 */
const LandingLayout = () => {
  return (
    <div className="landing-page-container w-full min-h-screen bg-black">
      <Outlet />
    </div>
  );
};

export default LandingLayout;
